import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import axiosInstance from 'services/axiosInstance';

interface ApiError {
    message: string;
    errors?: Record<string, string[]>;
    error: string;
}

interface ApiResponse<T> {
    data: T;
    status: number;
}

/**
 * Função genérica para realizar requisições
 */
export default async function apiRequest<T>(
    url: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' = 'GET', // Método com valor padrão
    data?: Record<string, unknown>,
    config?: AxiosRequestConfig
): Promise<ApiResponse<T>> {
    try {
        const response = await axiosInstance.request<T>({
            method,
            url,
            data,
            ...config,
        });
        return {
            data: response.data,
            status: response.status,
        };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError<ApiError>;
            if (axiosError.response) {
                const statusCode = axiosError.response.status;
                const errorData = axiosError.response.data;

                if (statusCode === 422) {
                    let errorMessages = "Por favor, corrija os seguintes erros:\n";

                    if (errorData.errors) {
                        for (const [field, messages] of Object.entries(errorData.errors)) {
                            errorMessages += `${messages.join(", ")}\n`;
                        }
                    }

                    throw {
                        error: errorData.error,
                        errors: errorData?.errors || {},
                        message: errorData.error || errorMessages || "Erro de credenciais",
                        status: statusCode,
                    };
                } else if (statusCode === 403) {
                    throw {
                        status: statusCode,
                        errors: errorData?.errors || {},
                        message: errorData.error || errorData?.errors  || "Erro de permissão",
                    };
                }

                throw {
                    status: statusCode,
                    errors: errorData?.errors || {},
                    message: errorData.error || errorData?.errors || "Erro desconhecido",
                };
            }
        }

        throw {
            message: "Erro desconhecido",
        };
    }
}
